import { PageTitleWithNav } from "../modules/PageHeaders";
import EMinuteEditor from "./modules/EMinuteEditor";
import { useNavigate, useParams } from "react-router-dom";
import { useGetSingleEminuteQuery } from "../../../store/admin/eminutesSlice";
import { dateFromString } from "../../../utils";
import useEminuteAction from "./useAdminEminuteActions";
import { useState, useEffect } from "react";

export const EminutePage = () => {
  const { updateMinute, changeStatus } = useEminuteAction();
  const navigate = useNavigate();
  const { id } = useParams();
  const { data = {}, isLoading, error } = useGetSingleEminuteQuery(id);
  const dateStr = data.created_at ? dateFromString(data.created_at) : "";
  const [dd, mm, yyyy] = dateStr ? dateStr.split("-") : ["", "", ""];
  const initialFormValues = {
    title: data.title || "",
    content: data.content || "",
    date: yyyy && mm && dd ? `${yyyy}-${mm}-${dd}` : "",
    audience: data.audience ?? "BOTH",
    send_sms: !!data.send_sms,
  };
  const [content, setContent] = useState(data.content || "");

  useEffect(() => {
    setContent(data.content || "");
  }, [data.content]);

  const handleSaveDraft = async (formikValues, formikHelpers) => {
    const reqBody = {
      ...formikValues,
      content,
      id,
      audience: formikValues.audience ?? "BOTH",
      send_sms: !!formikValues.send_sms,
    };
    const { data, error } = await updateMinute(reqBody);
    if (error || !data?.status) {
      throw new Error(error?.data?.message || data?.message || "Failed to update E-minute");
    }
  };

  const handleSaveAndPublish = async (formikValues, formikHelpers) => {
    const reqBody = {
      ...formikValues,
      content,
      id,
      audience: formikValues.audience ?? "BOTH",
      send_sms: !!formikValues.send_sms,
    };
    const { data: resData, error } = await updateMinute(reqBody);
    if (error || !resData?.status) {
      throw new Error(error?.data?.message || resData?.message || "Failed to update E-minute");
    }
    await changeStatus(id);
    // Navigate to list view on success
    navigate("/super_admin/eminutes");
  };

  if (error && error.status === 401) {
    navigate("/login");
  }
  return (
    <>
      {isLoading ? (
        <div className="py-4">loading...</div>
      ) : (
        <section className="mx-2 mx-lg-4 min-vh-100">
          <div className="py-1"></div>
          <PageTitleWithNav
            title={"Edit"}
            highlightText={data.title || ""}
            action={() => {
              navigate(-1);
            }}
          />
          <div>
            <EMinuteEditor
              initialValues={initialFormValues}
              handleContentChange={setContent}
              handleSaveDraft={handleSaveDraft}
              handleSaveAndPublish={handleSaveAndPublish}
            />
          </div>
        </section>
      )}
    </>
  );
};
